// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#userPreview {
  display: grid;
  grid-template-columns: auto auto;
  gap: 2rem;
  align-items: center;
  width: 100%;
  justify-content: start;
}

#userPreview span {
  color: var(--secondaryColor);
  font-size: medium;
  font-weight: bold;
}

.profilePicContainer {
  overflow: hidden;
  /* position: relative; */
  border-radius: 50%;
  height: 130px;
  width: 130px;
  border: 3px solid var(--secondaryColor);
  background-color: var(--lightGrey);
  top: -40px;
  display: flex;
  justify-content: center;
}

.profilePicContainer > img {
  object-fit: cover;
  text-align: center;
}

#progressBar {
  background-color: var(--mediumGrey);
  height: 10px;
  width: 100%;
  margin-bottom: 4rem;
  position: relative;
  display: flex;
  border-radius: 10px;
}

#progress {
  background-color: var(--primaryColor);
  height: 10px;
  width: 50%;
  border-radius: 10px;
}

.start,
.end {
  background-color: var(--darkColour);
  height: 12px;
  width: 12px;
  border-radius: 10px;
  position: absolute;
  top: -1px;
}

.start > span {
  display: flex;
  position: absolute;
  top: -23px;
}

.end > span {
  display: flex;
  position: absolute;
  top: -23px;
  left: -48px;
}

#progressBar > span {
  position: absolute;
  /* margin: auto; */
  left: 0;
  right: 0;
  top: -23px;
  text-align: center;
}

.start {
  top: -1px;
}

.end {
  right: 0;
}

#surveyIntro {
  width: 100%;
  /* justify-content: start;  */
}

/* #surveyIntro p {
    margin-left: 170px;
} */

#surveyQs {
  width: 100%;
}

#surveyHeaders {
  width: 100%;
}

#surveyHeaders h4 {
  margin-bottom: 0.5rem;
  color: var(--primaryColor);
}

.back {
  color: var(--secondaryColor);
  margin-bottom: 0.5rem;
  cursor: pointer;
}

.backChevron {
  fill: var(--secondaryColor);
  width: 14px;
  height: auto;
  transform: rotate(90deg);
}

.question {
  margin: 3rem 0;
}

.question > div > select {
  margin: 1.5rem 0 4rem 0;
}

/* rating */
.rating {
  position: relative;
  padding-top: 2rem;
}

.rating p:first-child {
  position: absolute;
  left: 0;
  top: 0;
}

.rating p:last-child {
  position: absolute;
  right: 0;
  top: 0;
}

/* Steps */

.ratingSteps {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.ratingItem {
  background-color: var(--mediumGrey);
  border-radius: 30px;
  width: 45px;
  height: 45px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  padding: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ratingLine {
  width: 100%;
  border: 4px solid var(--mediumGrey);
  background-color: var(--mediumGrey);
  margin-bottom: unset;
}

.selected {
  border-color: var(--secondaryColor);
  background-color: var(--secondaryColor);
}

.ratingActive {
  background-color: var(--secondaryColor);
  border-color: var(--secondaryColor);
}

/* slider */

.slider {
  display: flex;
  flex-direction: row;
  margin: 1.5rem 0 3rem 0;
  align-items: center;
}

input[type='range'] {
  -webkit-appearance: none;
  width: 100%;
  height: 7px;
  border-radius: 12px;
  background-color: var(--lightGrey);
  margin: 0 1rem;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  border-radius: 12px;
  width: 25px;
  height: 25px;
  background: var(--primaryColor);
  cursor: pointer;
}

input[type='range']::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: var(--primaryColor);
  cursor: pointer;
}

/* ======= TOOLTIP =============== */

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltiptext {
  visibility: hidden;
  position: absolute;
}

.tooltip:disabled .tooltiptext {
  visibility: hidden;
  width: inherit;
  background-color: var(--lightGrey);
  color: var(--fontColor);
  /* box-shadow: var(--shadow); */
  text-align: center;
  border-radius: 6px;
  padding: 0.5rem 0.2rem;
  font-size: 12px;
  font-weight: 400;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  left: 0;
  top: 3.5rem;
}

.tooltip:disabled .tooltiptext::after {
  content: '';
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
  background-color: var(--lightGrey);
  position: absolute;
  top: -0.5rem;
  left: calc(20% - 10px);
  /* box-shadow: var(--shadow); */
}

.tooltip:disabled:hover .tooltiptext {
  visibility: visible;
}

/* Radio */

.measureName {
  color: var(--secondaryColor);
}

.radioDivShort {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  gap: 1rem;
}

@media only screen and (max-width: 768px) {
  .radioDivShort {
    gap: 1rem;
  }
}

@media only screen and (max-width: 600px) {
  .radioDivShort {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 1rem;
    gap: 1.5rem;
  }
}

.radioDivLong {
  display: flex;
  width: 100%;
  margin-bottom: 3rem;
  gap: 1rem;
  flex-direction: column;
}

.radioDivLong > .radioItem {
  justify-content: flex-start;
  padding: 1.4rem 2.5rem;
  text-align: left;
}

.radioItem {
  padding: 1rem;
  box-shadow: var(--shadow);
  background-color: var(--lightGrey);
  color: var(--darkColour);
  border-radius: 10px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.radioItem:hover {
  background-color: var(--secondaryColorOpacity);
}

.radioActive {
  font-weight: 700;
  color: var(--darkColour);
  border: 2px solid var(--secondaryColor);
  background-color: var(--secondaryColorOpacity);
}

/* NOMINATIONS */

#nomSections {
  width: 100%;
}

.nomCards {
  display: grid;
  margin: 1.5rem 0 5rem 0;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem 1.5rem;
  justify-content: center;
  width: 100%;
}

@media only screen and (max-width: 1000px) {
  .nomCards {
    grid-template-columns: 1fr 1fr;
    width: 100%;
    gap: 1rem 1.5rem;
  }
}

.nomCard {
  background-color: var(--lightGrey);
  box-shadow: var(--shadow);
  border-radius: 12px;
  display: unset;
  position: relative;
  min-height: 100px;
  max-width: 300px;
  padding: 2rem 1.2rem 2rem 1.2rem;
  text-align: center;
  align-content: stretch;
  grid-template-rows: 80px auto;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nomHeader p:first-of-type {
  margin-bottom: 0.2rem;
}

.nomHeader p:last-of-type {
  color: var(--secondaryColor);
  margin-bottom: 1rem;
  font-style: italic;
  font-weight: 300;
}

.nomCard h6 {
  margin-bottom: 0.2rem;
}

.nomHeader h6 {
  color: var(--secondaryColor);
}

.removeCard {
  color: var(--primaryColor);
  fill: var(--primaryColor);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.4rem;
  cursor: pointer;
}

.removeCard svg {
  margin-right: 0.5rem;
}

.minRequired {
  font-weight: 400;
}

p > .required {
  color: var(--errorColor);
  background-color: unset;
  border: unset;
}

.nomEmpty {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--secondaryColorLight);
  color: white;
  fill: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  top: 0;
  left: 0;
}

.required {
  background-color: var(--errorColorLight);
  border: 2px solid var(--errorColor);
}

.nomTggl {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 2rem;
}

#existingNoms {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.relSelect {
  display: grid;
  justify-items: center;
}

.relSelect > .group {
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.cardRelTitle {
  color: var(--darkGrey);
}

.cardRelTitle > span {
  color: var(--darkColour);
}

.profileImgContainerCard {
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  height: 7rem;
  width: 7rem;
  border: 3px solid var(--secondaryColor);
  background-color: var(--lightGrey);
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.profileImgContainerCard > img {
  object-fit: cover;
  text-align: center;
}

/* SnakeBite / Double radio columns */
.snakeBiteGrid {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto auto;
  margin-bottom: 2rem;
}

.snakeBiteGrid h6 {
  margin: unset;
  border-bottom: 1px solid var(--mediumGrey);
}

.snakeBiteGrid > * {
  padding: 1rem;
  border-bottom: 1px solid var(--mediumGrey);
}

.snakeBiteGrid input {
  margin: auto;
  text-align: center;
}

#snakeQ,
.snakeQ {
}
`, "",{"version":3,"sources":["webpack://./src/styles/assessments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,kCAAkC;EAClC,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;;EAEhB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA,gBAAgB;;AAEhB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE;IACE,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,MAAM;EACN,OAAO;AACT;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uCAAuC;EACvC,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;AAEA","sourcesContent":["#userPreview {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 2rem;\n  align-items: center;\n  width: 100%;\n  justify-content: start;\n}\n\n#userPreview span {\n  color: var(--secondaryColor);\n  font-size: medium;\n  font-weight: bold;\n}\n\n.profilePicContainer {\n  overflow: hidden;\n  /* position: relative; */\n  border-radius: 50%;\n  height: 130px;\n  width: 130px;\n  border: 3px solid var(--secondaryColor);\n  background-color: var(--lightGrey);\n  top: -40px;\n  display: flex;\n  justify-content: center;\n}\n\n.profilePicContainer > img {\n  object-fit: cover;\n  text-align: center;\n}\n\n#progressBar {\n  background-color: var(--mediumGrey);\n  height: 10px;\n  width: 100%;\n  margin-bottom: 4rem;\n  position: relative;\n  display: flex;\n  border-radius: 10px;\n}\n\n#progress {\n  background-color: var(--primaryColor);\n  height: 10px;\n  width: 50%;\n  border-radius: 10px;\n}\n\n.start,\n.end {\n  background-color: var(--darkColour);\n  height: 12px;\n  width: 12px;\n  border-radius: 10px;\n  position: absolute;\n  top: -1px;\n}\n\n.start > span {\n  display: flex;\n  position: absolute;\n  top: -23px;\n}\n\n.end > span {\n  display: flex;\n  position: absolute;\n  top: -23px;\n  left: -48px;\n}\n\n#progressBar > span {\n  position: absolute;\n  /* margin: auto; */\n  left: 0;\n  right: 0;\n  top: -23px;\n  text-align: center;\n}\n\n.start {\n  top: -1px;\n}\n\n.end {\n  right: 0;\n}\n\n#surveyIntro {\n  width: 100%;\n  /* justify-content: start;  */\n}\n\n/* #surveyIntro p {\n    margin-left: 170px;\n} */\n\n#surveyQs {\n  width: 100%;\n}\n\n#surveyHeaders {\n  width: 100%;\n}\n\n#surveyHeaders h4 {\n  margin-bottom: 0.5rem;\n  color: var(--primaryColor);\n}\n\n.back {\n  color: var(--secondaryColor);\n  margin-bottom: 0.5rem;\n  cursor: pointer;\n}\n\n.backChevron {\n  fill: var(--secondaryColor);\n  width: 14px;\n  height: auto;\n  transform: rotate(90deg);\n}\n\n.question {\n  margin: 3rem 0;\n}\n\n.question > div > select {\n  margin: 1.5rem 0 4rem 0;\n}\n\n/* rating */\n.rating {\n  position: relative;\n  padding-top: 2rem;\n}\n\n.rating p:first-child {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rating p:last-child {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n/* Steps */\n\n.ratingSteps {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.ratingItem {\n  background-color: var(--mediumGrey);\n  border-radius: 30px;\n  width: 45px;\n  height: 45px;\n  color: #fff;\n  text-align: center;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.ratingLine {\n  width: 100%;\n  border: 4px solid var(--mediumGrey);\n  background-color: var(--mediumGrey);\n  margin-bottom: unset;\n}\n\n.selected {\n  border-color: var(--secondaryColor);\n  background-color: var(--secondaryColor);\n}\n\n.ratingActive {\n  background-color: var(--secondaryColor);\n  border-color: var(--secondaryColor);\n}\n\n/* slider */\n\n.slider {\n  display: flex;\n  flex-direction: row;\n  margin: 1.5rem 0 3rem 0;\n  align-items: center;\n}\n\ninput[type='range'] {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 7px;\n  border-radius: 12px;\n  background-color: var(--lightGrey);\n  margin: 0 1rem;\n}\n\ninput[type='range']::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  border-radius: 12px;\n  width: 25px;\n  height: 25px;\n  background: var(--primaryColor);\n  cursor: pointer;\n}\n\ninput[type='range']::-moz-range-thumb {\n  width: 25px;\n  height: 25px;\n  background: var(--primaryColor);\n  cursor: pointer;\n}\n\n/* ======= TOOLTIP =============== */\n\n.tooltip {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltiptext {\n  visibility: hidden;\n  position: absolute;\n}\n\n.tooltip:disabled .tooltiptext {\n  visibility: hidden;\n  width: inherit;\n  background-color: var(--lightGrey);\n  color: var(--fontColor);\n  /* box-shadow: var(--shadow); */\n  text-align: center;\n  border-radius: 6px;\n  padding: 0.5rem 0.2rem;\n  font-size: 12px;\n  font-weight: 400;\n\n  /* Position the tooltip */\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 3.5rem;\n}\n\n.tooltip:disabled .tooltiptext::after {\n  content: '';\n  width: 20px;\n  height: 20px;\n  transform: rotate(-45deg);\n  background-color: var(--lightGrey);\n  position: absolute;\n  top: -0.5rem;\n  left: calc(20% - 10px);\n  /* box-shadow: var(--shadow); */\n}\n\n.tooltip:disabled:hover .tooltiptext {\n  visibility: visible;\n}\n\n/* Radio */\n\n.measureName {\n  color: var(--secondaryColor);\n}\n\n.radioDivShort {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  gap: 1rem;\n}\n\n@media only screen and (max-width: 768px) {\n  .radioDivShort {\n    gap: 1rem;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .radioDivShort {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n    gap: 1.5rem;\n  }\n}\n\n.radioDivLong {\n  display: flex;\n  width: 100%;\n  margin-bottom: 3rem;\n  gap: 1rem;\n  flex-direction: column;\n}\n\n.radioDivLong > .radioItem {\n  justify-content: flex-start;\n  padding: 1.4rem 2.5rem;\n  text-align: left;\n}\n\n.radioItem {\n  padding: 1rem;\n  box-shadow: var(--shadow);\n  background-color: var(--lightGrey);\n  color: var(--darkColour);\n  border-radius: 10px;\n  width: 100%;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.radioItem:hover {\n  background-color: var(--secondaryColorOpacity);\n}\n\n.radioActive {\n  font-weight: 700;\n  color: var(--darkColour);\n  border: 2px solid var(--secondaryColor);\n  background-color: var(--secondaryColorOpacity);\n}\n\n/* NOMINATIONS */\n\n#nomSections {\n  width: 100%;\n}\n\n.nomCards {\n  display: grid;\n  margin: 1.5rem 0 5rem 0;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 1rem 1.5rem;\n  justify-content: center;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1000px) {\n  .nomCards {\n    grid-template-columns: 1fr 1fr;\n    width: 100%;\n    gap: 1rem 1.5rem;\n  }\n}\n\n.nomCard {\n  background-color: var(--lightGrey);\n  box-shadow: var(--shadow);\n  border-radius: 12px;\n  display: unset;\n  position: relative;\n  min-height: 100px;\n  max-width: 300px;\n  padding: 2rem 1.2rem 2rem 1.2rem;\n  text-align: center;\n  align-content: stretch;\n  grid-template-rows: 80px auto;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.nomHeader p:first-of-type {\n  margin-bottom: 0.2rem;\n}\n\n.nomHeader p:last-of-type {\n  color: var(--secondaryColor);\n  margin-bottom: 1rem;\n  font-style: italic;\n  font-weight: 300;\n}\n\n.nomCard h6 {\n  margin-bottom: 0.2rem;\n}\n\n.nomHeader h6 {\n  color: var(--secondaryColor);\n}\n\n.removeCard {\n  color: var(--primaryColor);\n  fill: var(--primaryColor);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1.4rem;\n  cursor: pointer;\n}\n\n.removeCard svg {\n  margin-right: 0.5rem;\n}\n\n.minRequired {\n  font-weight: 400;\n}\n\np > .required {\n  color: var(--errorColor);\n  background-color: unset;\n  border: unset;\n}\n\n.nomEmpty {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: var(--secondaryColorLight);\n  color: white;\n  fill: white;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1rem;\n  top: 0;\n  left: 0;\n}\n\n.required {\n  background-color: var(--errorColorLight);\n  border: 2px solid var(--errorColor);\n}\n\n.nomTggl {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  margin-bottom: 2rem;\n}\n\n#existingNoms {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.relSelect {\n  display: grid;\n  justify-items: center;\n}\n\n.relSelect > .group {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n\n.cardRelTitle {\n  color: var(--darkGrey);\n}\n\n.cardRelTitle > span {\n  color: var(--darkColour);\n}\n\n.profileImgContainerCard {\n  overflow: hidden;\n  position: relative;\n  border-radius: 50%;\n  height: 7rem;\n  width: 7rem;\n  border: 3px solid var(--secondaryColor);\n  background-color: var(--lightGrey);\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.profileImgContainerCard > img {\n  object-fit: cover;\n  text-align: center;\n}\n\n/* SnakeBite / Double radio columns */\n.snakeBiteGrid {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  margin-bottom: 2rem;\n}\n\n.snakeBiteGrid h6 {\n  margin: unset;\n  border-bottom: 1px solid var(--mediumGrey);\n}\n\n.snakeBiteGrid > * {\n  padding: 1rem;\n  border-bottom: 1px solid var(--mediumGrey);\n}\n\n.snakeBiteGrid input {\n  margin: auto;\n  text-align: center;\n}\n\n#snakeQ,\n.snakeQ {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
